import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";

// Validación
const channelSchema = yup.object().shape({
    name: yup.string().required("El nombre es requerido"),
    //description: yup.string().max(255, "Máximo 255 caracteres"),
});

const ChannelDialog = ({ open, onClose, item = null, onSave }) => {
    const isEdit = Boolean(item?.customer_acquisition_channel_id);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = {
                ...values,
                status: '1',
            };
            await onSave(payload);
            onClose();
        } catch (error) {
            console.error("Error al guardar el canal:", error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEdit ? "Editar Canal" : "Crear Canal"}</DialogTitle>

            <Formik
                initialValues={{
                    customer_acquisition_channel_id: item?.customer_acquisition_channel_id || null,
                    name: item?.name || "",
                    description: item?.description || "",
                }}
                validationSchema={channelSchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    touched,
                    errors,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent sx={{ display: "grid", gap: 2 }}>
                            <TextField
                                label="Nombre *"
                                name="name"
                                fullWidth
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!touched.name && !!errors.name}
                                helperText={touched.name && errors.name}
                            />

                            <TextField
                                label="Descripción"
                                name="description"
                                fullWidth
                                multiline
                                minRows={3}
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!touched.description && !!errors.description}
                                helperText={touched.description && errors.description}
                            />
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={onClose} color="inherit">
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                            >
                                {isEdit ? "Actualizar" : "Crear"}
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ChannelDialog;
